import axios from 'axios';
import { API_URL } from '../config';

export const fetchCountries = async () => {
  const URL = `${API_URL}/country`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
};

export const fetchStates = async () => {
  const URL = `${API_URL}/ra-state`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
};

export const fetchCityVillages = async (regionId) => {
  const URL = `${API_URL}/ra-state/${regionId}/city-village`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
};
